// extracted by mini-css-extract-plugin
module.exports = {"navLink":"Bl","linkButton":"Bm","navLinkWhileSearching":"Bn"};